var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea"},[_c('v-textarea',_vm._g(_vm._b({style:(_vm.styles)},'v-textarea',_vm.$props,false),_vm.textListener))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }